import { render } from "./DetailData.vue?vue&type=template&id=8bc59124&scoped=true"
import script from "./DetailData.vue?vue&type=script&lang=js"
export * from "./DetailData.vue?vue&type=script&lang=js"

import "./DetailData.vue?vue&type=style&index=0&id=8bc59124&scoped=true&lang=css"
import "./DetailData.vue?vue&type=style&index=1&id=8bc59124&lang=less&scoped=true"

import exportComponent from "/Users/qiao/KaungSpace/DevSpace/KaungAdmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bc59124"]])

export default __exports__